import { useIntl } from 'react-intl'
import BaseTransportSummary from './BaseTransportSummary'

import type { FerryItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: FerryItem
}

function FerryItemSummary(props: Props) {
  const intl = useIntl()
  return <BaseTransportSummary
    transportName={intl.formatMessage({
      id: 'c4LnpOYxlmxmRdP_kxm6',
      defaultMessage: 'Ferry',
      description: 'Transport type name for ferry used in trip item summary heading',
    })}
    {...props}
  />
}

export default FerryItemSummary
